export function previewOrientation(height, width){
  let orientation = 'portrait'

  if (width >= height){
    orientation = 'landscape'
  }

  return orientation
}

export function previewScale(orientation, holderSize, width, height){
  const holderPadding = holderSize.padding * 2

  const landscapeScale = (holderSize.width - holderPadding) / width
  const portraitScale = (holderSize.height - holderPadding) / height

  // Check that the height and width will fit if using the scale
  const fitsHeight = (height * landscapeScale) < (holderSize.height - holderPadding)

  if (orientation === 'landscape' && fitsHeight){
    return landscapeScale
  }

  return portraitScale
}

export function previewMargins(orientation, holderSize, imageSize){
  const margins = {
    top: orientation === 'landscape' ? (holderSize.height - imageSize.height) / 2 : holderSize.padding,
    left: orientation === 'portrait' ? (holderSize.width - imageSize.width) / 2 : holderSize.padding,
  }

  return margins
}
